module.exports = __webpack_public_path__ + "static/img/platphom8.9a38af4a.png";